import { createContext, useContext } from 'react';
import { AuthViewType } from '../AuthButtonProps';

export interface NewAuthFormState {
    view: AuthViewType;
    setView: (view: AuthViewType) => void;
    title: string;
    cta?: string;
    from?: string;
    isNewUser?: (value: boolean) => void;
}

export const NewAuthFormContext = createContext<NewAuthFormState>({
    view: 'main',
    setView: () => void 0,
    title: 'Wooter',
    cta: null,
    from: null,
    isNewUser: () => void 0,
});

export const useNewAuthForm = () => useContext(NewAuthFormContext);
